import { Delivery } from '@depop/web-thrift-ui/Icons/Delivery';
import { DepopProtection } from '@depop/web-thrift-ui/Icons/DepopProtection';
import { Selling } from '@depop/web-thrift-ui/Icons/Selling';
import { Suggestion } from '@depop/web-thrift-ui/Icons/Suggestion';

import { type PropositionConfig } from './types';

import { HELP_ARTICLES } from '@/constants/helpUrls';

export const NUMBER_OF_POPULAR_PRODUCTS_ON_HOMEPAGE = 12;

const assetsUrl = process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST;

export const HERO_IMAGE_WIDTHS = {
  mobile: 1012,
  desktop: 2000,
} as const;

export const HERO_IMAGE_HEIGHT = 592;

export const HERO_FALLBACK_IMAGES = {
  buy: {
    mobile: `${assetsUrl}/web/assets/dual-homepage/hero/2026-07/buyer-mobile@2x.webp`,
    desktop: `${assetsUrl}/web/assets/dual-homepage/hero/2026-07/buyer-desktop@2x.webp`,
    alt: 'Person joyfully holding an armful of vintage sneakers including Nike and Adidas styles, alongside a mirror selfie showing a red structured handbag',
  },
  sell: {
    mobile: `${assetsUrl}/web/assets/dual-homepage/hero/2026-06/seller-mobile@2x.webp`,
    desktop: `${assetsUrl}/web/assets/dual-homepage/hero/2026-06/seller-desktop@2x.webp`,
    alt: 'Models wearing secondhand fashion including a pink bow cardigan with floral skirt and a red printed sundress, styled at a retro diner setting',
  },
};

export const SELL_PROPOSITIONS: PropositionConfig[] = [
  {
    icon: DepopProtection,
    titleKey: 'DualProposition.SellCard.Title.SellSafely',
    descriptionKey: 'DualProposition.SellCard.Description.SellSafely',
    href: HELP_ARTICLES.DEPOP_PROTECTION_FOR_SELLERS,
  },
  {
    icon: Suggestion,
    titleKey: 'DualProposition.SellCard.Title.ListFast',
    descriptionKey: 'DualProposition.SellCard.Description.ListFast',
  },
  {
    icon: Delivery,
    titleKey: 'DualProposition.SellCard.Title.ShipEasily',
    descriptionKey: 'DualProposition.SellCard.Description.ShipEasily',
  },
];

export const BUY_PROPOSITIONS: PropositionConfig[] = [
  {
    icon: Selling,
    titleKey: 'DualProposition.BuyCard.Title.ItemsForSale',
    descriptionKey: 'DualProposition.BuyCard.Description.ItemsForSale',
  },
  {
    icon: Suggestion,
    titleKey: 'DualProposition.BuyCard.Title.NewListings',
    descriptionKey: 'DualProposition.BuyCard.Description.NewListings',
  },
  {
    icon: DepopProtection,
    titleKey: 'DualProposition.BuyCard.Title.BuySafely',
    descriptionKey: 'DualProposition.BuyCard.Description.BuySafely',
    href: HELP_ARTICLES.BUYER_PROTECTION,
  },
];

export const EBAY_BUY_PROPOSITIONS: PropositionConfig[] = [
  {
    icon: Delivery,
    titleKey: 'EbayDualProposition.BuyCard.Title.ItemsForSale',
    descriptionKey: 'EbayDualProposition.BuyCard.Description.ItemsForSale',
  },
  {
    icon: Suggestion,
    titleKey: 'EbayDualProposition.BuyCard.Title.NewListings',
    descriptionKey: 'EbayDualProposition.BuyCard.Description.NewListings',
  },
  {
    icon: DepopProtection,
    titleKey: 'EbayDualProposition.BuyCard.Title.BuySafely',
    descriptionKey: 'EbayDualProposition.BuyCard.Description.BuySafely',
    href: HELP_ARTICLES.BUYER_PROTECTION,
  },
];

export const EBAY_SELL_PROPOSITIONS: PropositionConfig[] = [
  {
    icon: DepopProtection,
    titleKey: 'EbayDualProposition.SellCard.Title.SellSafely',
    descriptionKey: 'EbayDualProposition.SellCard.Description.SellSafely',
    href: HELP_ARTICLES.DEPOP_PROTECTION_FOR_SELLERS,
  },
  {
    icon: Suggestion,
    titleKey: 'EbayDualProposition.SellCard.Title.ListFast',
    descriptionKey: 'EbayDualProposition.SellCard.Description.ListFast',
  },
  {
    icon: Delivery,
    titleKey: 'EbayDualProposition.SellCard.Title.ShipEasily',
    descriptionKey: 'EbayDualProposition.SellCard.Description.ShipEasily',
  },
];
